import { Form, Radio } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';

const ServicesForm: React.FunctionComponent = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Form.Section
        label={formatMessage({ id: 'provider.onboarding.form.services.title' })}
        description={formatMessage({ id: 'provider.onboarding.form.services.description' })}
      >
        <Form.Field name={'servicesType'}>
          <Radio.Group>
            <Radio value={'withoutGuarantor'}>
              {formatMessage({ id: 'provider.onboarding.form.services.without.guarantor' })}
            </Radio>
            <Radio value={'withGuarantor'}>
              {formatMessage({ id: 'provider.onboarding.form.services.with.guarantor' })}
            </Radio>
          </Radio.Group>
        </Form.Field>
      </Form.Section>
    </>
  );
};

export default ServicesForm;
